import { render } from "./ClienteContactoModal.vue?vue&type=template&id=183115f1"
import script from "./ClienteContactoModal.vue?vue&type=script&lang=js"
export * from "./ClienteContactoModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__